<footer>
    <h2>Hello FireBase</h2>
</footer>